import { toaster as ordersToaster } from "@hydrologiq/shared/chakra/Toaster"

// Export the toaster instance for testing
export { ordersToaster }

export const showSuccessToast = (title: string, description?: string) => {
  ordersToaster.create({
    title,
    description,
    type: "success",
    duration: 2000,
  })
}

export const showErrorToast = (title: string, description?: string) => {
  ordersToaster.create({
    title,
    description,
    type: "error",
    duration: 4000,
  })
}

export const showLoadingToast = (title: string, description?: string) => {
  return ordersToaster.create({
    title,
    description,
    type: "loading",
  })
}

export const showWarningToast = (title: string, description?: string) => {
  ordersToaster.create({
    title,
    description,
    type: "warning",
    duration: 3000,
  })
}

export const dismissToast = (id?: string) => {
  if (id) {
    ordersToaster.dismiss(id)
  } else {
    ordersToaster.dismiss()
  }
}
